import { PlaceholderIcon } from '@synergy/theme-next';
import { ReactElement } from 'react';
import { styled } from '@mui/material';

import { SupplierSpecialOffer } from '../../../../../models/supplier-special-offer';

const SpecialOfferImage = styled('img')(() => ({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
}));

const SupplierLogo = styled('img')(() => ({
    width: '100%',
    height: '100%',
    objectFit: 'contain',
}));

const ImagePlaceholder = styled(PlaceholderIcon)(() => ({
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    style: {
        maxWidth: '255px',
    },
}));

interface CardImageProps {
    specialOffer: SupplierSpecialOffer;
    imageError: boolean;
    onError: (hasError: boolean) => void;
}

export const CardImage = (props: CardImageProps): ReactElement => {
    const { specialOffer, imageError, onError } = props;

    if (specialOffer.image && !imageError) {
        return (
            <SpecialOfferImage
                src={specialOffer.image['489x274']}
                alt={specialOffer.supplier.name}
                onError={() => onError(true)}
            />
        );
    }

    if (specialOffer.supplier.image && !imageError) {
        return (
            <SupplierLogo
                src={specialOffer.supplier.image['255x109']}
                alt={specialOffer.supplier.name}
                onError={() => onError(true)}
            />
        );
    }

    return <ImagePlaceholder />;
};
